import React from "react";
import { Input } from "components/Input";
import { Body, Header } from "components/Table/style";
import { Col, Row } from "styles";
import { Table } from "../../style";

export function Anticoccidian(props) {
  return (
    <>
      <Row>
        <Col>
          <Table>
            <Header>
              <tr>
                <th style={{ width: "185px" }}>
                  <span></span>
                </th>
                <th>
                  <span>Qual molécula utiliza atualmente?</span>
                </th>
                <th>
                  <span>Qual PPM?</span>
                </th>
              </tr>
            </Header>
            <Body>
              <tr>
                <td>
                  <span>Pré</span>
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="health.anticoccidian.moleculePre"
                    item={props.megg}
                    setItem={props.setMegg}
                    placeholder="Digite a molécula"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="health.anticoccidian.dosePre"
                    item={props.megg}
                    setItem={props.setMegg}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <span>Inicial</span>
                </td>

                <td>
                  <Input
                    type="inputOnly"
                    params="health.anticoccidian.moleculeInitial"
                    item={props.megg}
                    setItem={props.setMegg}
                    placeholder="Digite a molécula"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="health.anticoccidian.doseInitial"
                    item={props.megg}
                    setItem={props.setMegg}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <span>Crescimento</span>
                </td>

                <td>
                  <Input
                    type="inputOnly"
                    params="health.anticoccidian.moleculeGrowth"
                    item={props.megg}
                    setItem={props.setMegg}
                    placeholder="Digite a molécula"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="health.anticoccidian.doseGrowth"
                    item={props.megg}
                    setItem={props.setMegg}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <span>Desenvolvimento</span>
                </td>

                <td>
                  <Input
                    type="inputOnly"
                    params="health.anticoccidian.moleculeDevelopment"
                    item={props.megg}
                    setItem={props.setMegg}
                    placeholder="Digite a molécula"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="health.anticoccidian.doseDevelopment"
                    item={props.megg}
                    setItem={props.setMegg}
                  />
                </td>
              </tr>
            </Body>
          </Table>
        </Col>
      </Row>
      <Row>
        <Col>
          <Input
            type="checkbox"
            params="health.anticoccidian.additional"
            item={props.megg}
            setItem={props.setMegg}
            label="Utiliza tratamento adicional a
            coccidiose"
            className="kt-checkbox mt-2"
          />
        </Col>
      </Row>
    </>
  );
}
